// What a plate check may record (POST /plates/{id}/checks, routes/plate_checks.py).
// Shared by the bench screen (pages/Lab.js) and the home hub's quick "Log check"
// form (components/hub/quick), so the two offer the same choices.

// plate_status values a check may set. transferred_to_plate/_slants are
// reached only by completing a transfer and awaiting_creation only by plate
// creation; the route refuses all three here.
export const CHECK_STATUSES = [
  'pending', 'ready_to_transfer', 'slow_growth', 'contaminated',
  'in_rescue', 'failed',
];

// contamination_type (sent only with status 'contaminated').
export const CONTAMINATION_TYPES = [
  'bacterial_mold_mild', 'bacterial_mold_moderate', 'bacterial_mold_severe',
  'suspected_mold',
];
